export default __webpack_public_path__ + "static/media/Encryption_In_Progress.9ae0c1f4.png";